/* DON'T EDIT THIS FILE: edit original and run build again */ // Missing onboarding terms of use title for UG Valores tenant
export const onboardingTermsOfUseTitle =
  "CONVENIO ENTRE EL COMITENTE Y UG VALORES";
